import { frontendURL } from '../../../../helper/URLHelper';

const dashboard_embed = accountId => ({
  parentNav: 'dashboard_embed',
  routes: [
    'dashboard_embed',
  ],
  menuItems: [
    {
      icon: 'contact-card-group',
      label: 'DASHBOARD_EMBED',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/dashboard_embed`),
      toStateName: 'dashboard_embed',
    }
  ],
});

export default dashboard_embed;
